import React, {useMemo} from "react";
import Tr from "translations/Translations";
import Dialog from "components/Dialog";
import MultiButton, {createButton} from "components/popup/components/MultiButton";
import GridBlock from "components/GridBlock";
import Button from "components/Button";
import {connect} from "react-redux";
import ShareIcon from "@material-ui/icons/Share";
import {shareSystemsActive, shareSystemsConnected} from "libs/shareSystems";
import PropTypes from "prop-types";
import TypographyWithIcon from "components/TypographyWithIcon";
import SendIcon from '@material-ui/icons/Send';

export const sharePopupData = (name, payload) => ({name, payload})

const ShareSelectPopup = (
    {
        data,
        onCancel,
        onChoose,
        demandHeader
    }) => {

    const activeShareSystems = useMemo(() => shareSystemsActive(demandHeader), [demandHeader])
    const connectedShareSystems = useMemo(() => shareSystemsConnected(demandHeader), [demandHeader])

    const getButtons = () => {
        const buttons = [];
        buttons.push(createButton(Tr('cancel'), onCancel));
        return buttons;
    }
    return (<Dialog
        open
        title={Tr("int_choose_popup_title")}
        maxWidth='sm'
        onClose={onCancel}
        dialogActions={<MultiButton buttons={getButtons()}/>}
    >
        <TypographyWithIcon Icon={SendIcon}>{data.name}</TypographyWithIcon>
        <br/>
        <GridBlock justify="center" alignItems="center">
            {
                activeShareSystems.map(x =>
                    <Button key={x}
                            disabled={!connectedShareSystems.includes(x)}
                            tooltip={!connectedShareSystems.includes(x) ? Tr("int_demand_not_connected_x", {x}, true) : undefined}
                            onClick={() => onChoose(data.payload, x)}
                            Icon={ShareIcon}
                    >{Tr("int_upload_x", {x}, true)}</Button>)
            }
        </GridBlock>
    </Dialog>)
}

ShareSelectPopup.propTypes = {
    data: PropTypes.shape({
        name: PropTypes.string.isRequired,
        payload: PropTypes.object,
    }).isRequired,
    onCancel: PropTypes.func.isRequired,
    onChoose: PropTypes.func.isRequired,
}

export default connect((state) => ({
    demandHeader: state.resources.demandHeader
}), {})(ShareSelectPopup)